import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import * as apiUrl from "../../apiUrl";

function InvestorBanner() {

  const [InvestorBanner, setInvestorBanner] = useState([]);

  useEffect(() => {
    const fetchInvestorBanner = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/invetors-relation/banner-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setInvestorBanner(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchInvestorBanner();
  }, []);

  return ( 
      <div
        className="common-banner-sec common-flex-center investor-banner"
        style={{
          backgroundImage: `url(${
            apiUrl.apiUrl + `/` + InvestorBanner.banner_image
          })`,
        }}
      >
        <div className="overlay"></div>
        <Container fluid>
          <Row className="common-flex-center">
            <Col md={8}>
              <div className=" ">
                <h1 className="common-head whiteColor">{InvestorBanner.banner_title}</h1>
              </div>
            </Col>
          </Row>
        </Container>
      </div> 
  );
}

export default InvestorBanner;
